import React, {useRef, useState} from "react";
import "./../../../App.css"
import "./RecruitmentCardKam.css"
import ModalFormKam from "./ModalFormKam";

export const RecruitmentCardKam = ({entity}) => {

    const [showMore, setShowMore] = useState(false)
    const showMoreFunc = (e) => {
        setShowMore(!showMore)
    }

    const [lgShow, setLgShow] = useState(false);

        return (
            <div className="job">
                <div className="job_title">{entity.name}</div>
                <div className="job_city">{entity.cityName}</div>
              <div className="buttons">
                <button id="more" onClick={e => showMoreFunc(e)}>Отвори оглас {!showMore ?
                  <i className="fa fa-chevron-down m-lg-2"/> : <i className="fa fa-chevron-up m-lg-2"/>}
                  </button>
                  <ModalFormKam type={entity.employeeTypeId} externalRecruitmentId={entity.externalRecruitmentId}
                              title={entity.name} lgShow={lgShow} setLgShow={setLgShow}/>
              </div>
              {showMore &&
                <div className="job_info">
                        {entity.hasAttachment ?
                            <>
                                <img src={`https://api.kam-kariera.mk/data/rest/attachments/get_recruitment_image_by_object_id/${entity.externalRecruitmentId}`}
                                     onClick={() => setLgShow(true)}/>
                                {/*<img src={`http://localhost:3000/data/rest/attachments/get_recruitment_image_by_object_id/${entity.externalRecruitmentId}`}*/}
                                {/*onClick={() => setLgShow(true)}/>*/}
                                <div className="col-12 job_info_apply_button">
                                    <ModalFormKam type={entity.employeeTypeId}
                                                  externalRecruitmentId={entity.externalRecruitmentId}
                                                  title={entity.name} lgShow={lgShow} setLgShow={setLgShow}
                                                  widthClass="w-100"/>
                                </div>
                            </>
                            : <div className="job_info_details">
                                <div className="job_description">
                                    {entity.workingPositionDescription}
                                </div>
                                <div className="job_benefits">
                                    {entity.description}
                                </div>
                                <div className="job_salary">
                                    Од прв месец од <span>{entity.salary} ден.</span>
                                </div>
                                <div className="job_salary">
                                    Остварена продуктивност до <span>{entity.points} ден.</span>
                                </div>
                                <div className="col-12 job_info_apply_button">
                                    <ModalFormKam type={entity.employeeTypeId}
                                                  externalRecruitmentId={entity.externalRecruitmentId}
                                                  title={entity.name} lgShow={lgShow} setLgShow={setLgShow}
                                                  widthClass="w-100"/>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>


        )
    };
export default RecruitmentCardKam;